// Node Modules
import React from "react";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import renderHTML from "react-render-html";

import "./press.css";

class Press extends React.Component {
  render() {
    return (
      <div className="content press">
        {renderHTML(documentToHtmlString(this.props.content))}
      </div>
    );
  }
}
export default Press;
